export var TranslationResource = {
    vel_form_field_label_optional: 'optional',
    vel_date_picker_invalid_input_value: 'Invalid',
};
//# sourceMappingURL=TranslationResource.js.map